export default "__VITE_ASSET__Dv6j1uUv__"